export default __webpack_public_path__ + "media/images/badge-level2-size12-9247027ea44d3c9f54f3aa7ee30fb8da.png";